var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstroG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41699 11.9566C2.41699 17.8327 7.2738 20.9639 10.8291 23.7667C12.0837 24.7557 13.292 25.6868 14.5003 25.6868C15.7087 25.6868 16.917 24.7557 18.1716 23.7667C21.7269 20.9639 26.5837 17.8327 26.5837 11.9566C26.5837 6.0806 19.9376 1.91342 14.5003 7.56258C9.06302 1.91342 2.41699 6.0806 2.41699 11.9566Z",
    fill: "#E654A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstroG);
export default __webpack_public_path__ + "static/media/astroG.739381d7c71c10080a52645bc0fce6d4.svg";
export { ForwardRef as ReactComponent };